export default __webpack_public_path__ + "static/media/checkers-5-rMAX.7cac6766.jpg";